export function appendToBody(elementString) {
    const template = document.createElement('template');
    template.innerHTML = elementString.trim();
    document.body.appendChild(template.content);
}